// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"104":"20204e0e2c856cd1","669":"8f3e22602bba3a53","754":"464f6ac04f15fa09","763":"fccac4a31a60c2e4","770":"655968524c9c5e44"}[chunkId] + ".js";
};